'use strict'

import React, {Component} from 'react';
import '../styles/App.css';
import firebase from './firebaseConnection';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Judges extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount () { //componentDidUpdate
    firebase.database().ref('Judges-business ideas').once('value').then(snapshot => {
      this.setState({ items: snapshot.val()})
    })
  }

  Judges(item) {
    return (
      <div key={item.name} className="Judges">
        <img className="Judges" src={item.Image}/>
        <h2 className="Judges">
          <h1 className="Judges">{item.Name}</h1>
          {item.Title}
        </h2>
        <a className="Judges" onClick={this.toggle.bind(this, item)}>Mas información</a>
      </div>
  )
  }

  toggle(item) {
    if (item !== undefined) {
      this.setState({
        name: item.Name,
        resume: item.Resume,
        image: item.Image,
        modal: !this.state.modal
      })
      if (item.Name === "Avantica") {
        this.setState({id: 0})
      } else if (item.Name === "GoLabs") {
        this.setState({id: 1})
      } else if (item.Name === "Ubitec") {
        this.setState({id: 2})
      }
    }
    else {
      this.setState({
        modal: !this.state.modal
      })
    }
  }


  render() {
    var Judges = this.state.items.map(this.Judges.bind(this));
    return (
      <div className="interviewsDiv">
        {Judges}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
         <ModalHeader>{this.state.name}</ModalHeader>
         <ModalBody className="JudgesModal">
           <img className="JudgesImgModal" src={this.state.image}/>
           <br/>
           <p className="Judges">{this.state.resume}</p>
         </ModalBody>
         <ModalFooter>
           <Button color="secondary" onClick={this.toggle}>Cerrar</Button>
         </ModalFooter>
       </Modal>
      </div>

    );
  };
}

export default Judges;



// WEBPACK FOOTER //
// ./src/app/getJudges.js